// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap-4ee38b","wrap_absolute":"wrap_absolute-4ee38b","img":"img-4ee38b"};